import type { IPatientSchedule } from 'features/Home/interfaces/IInfoSchedule'
import { resolveScheduleRoomId } from './helpers'
import {
  getScheduleStaffColor,
  getScheduleStaffId,
  isWaitingRoomSchedule,
} from './scheduleInstance'

export const applyStaffColorToken = (
  element: HTMLElement,
  event: Pick<IPatientSchedule, 'consultation_staff'>,
): void => {
  const color = getScheduleStaffColor(getScheduleStaffId(event))
  element.style.setProperty('--staff-color', color)
  element.style.setProperty('--staff-color-ink', '#fff')
}

export const applyStaffFocus = (
  element: HTMLElement,
  event: Pick<IPatientSchedule, 'consultation_staff' | 'room' | 'room_id'> & {
    room_type_id?: number
  },
  focusedStaffIds: number[] | null | undefined,
  waitingRoomResourceId?: string,
): void => {
  const inWaitingRoom =
    isWaitingRoomSchedule(event) ||
    (Boolean(waitingRoomResourceId) &&
      resolveScheduleRoomId(event.room_id) === waitingRoomResourceId)

  if (!focusedStaffIds?.length || inWaitingRoom) {
    element.classList.remove('schedule-event--dim', 'schedule-event--focus')
    return
  }

  const on = focusedStaffIds.includes(getScheduleStaffId(event))
  element.classList.toggle('schedule-event--dim', !on)
  element.classList.toggle('schedule-event--focus', on)
}
